import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import ItemRoomTypeListPage from './ItemRoomTypeList';
import ItemRoomTypeModalPage from './ItemRoomTypeModal';
import ItemRoomTypeSearchRoomModal from './ItemRoomTypeSearchItemModal';
import ItemRoomTypeSearchTypeModal from './ItemRoomTypeSearchRoomTypeModal';
import './ItemRoomType.css';

@inject('ItemRoomTypeStore')
@observer
class ItemRoomTypePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    // ON CANCEL

    itemRoomTypeModalOnCancel = () => {
        this.props.ItemRoomTypeStore.setShowItemRoomTypeModal(false);
    }

    itemSearchModalOnCancel = () => {
        this.props.ItemRoomTypeStore.setShowItemSearchModal(false);
    }

    roomTypeSearchModalOnCancel = () => {
        this.props.ItemRoomTypeStore.setShowRoomTypeSearchModal(false);
    }

    render() {
        const {
            showItemRoomTypeModal,
            itemRoomTypeTitle,
            showItemSearchModal,
            showRoomTypeSearchModal
        } = this.props.ItemRoomTypeStore;

        return (
            <MainContainer title='Item Room Type' menukey='item-room-type'>
                <Modal
                    title={itemRoomTypeTitle}
                    visible={showItemRoomTypeModal}
                    width={800}
                    footer={null}
                    onCancel={this.itemRoomTypeModalOnCancel}
                    zIndex={1000}
                >
                    <ItemRoomTypeModalPage />
                </Modal>

                <Modal
                    title='Search Item'
                    visible={showItemSearchModal}
                    width={800}
                    footer={null}
                    onCancel={this.itemSearchModalOnCancel}
                    zIndex={2000}
                >
                    <ItemRoomTypeSearchRoomModal />
                </Modal>

                <Modal
                    title='Search Room Type'
                    visible={showRoomTypeSearchModal}
                    width={800}
                    footer={null}
                    onCancel={this.roomTypeSearchModalOnCancel}
                    zIndex={2000}
                >
                    <ItemRoomTypeSearchTypeModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <ItemRoomTypeListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default ItemRoomTypePage;